import { useMemo } from 'react';

import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseScoreCardProvider } from 'components/widgets/ProjectSummary/ProjectSummary.provider';

interface Props {
    api: UseScoreCardProvider['api'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
}

export const useProjectSummaryLogic = ({ api, setIsPayloadReady, widgetViewMode }: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getProjectStatusScoreCards.payload;
        if (!currentPayload) return;
        if (
            currentPayload.compareVersionId === undefined ||
            currentPayload.latestVersionId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });

    const qualityCardData = useMemo(
        () =>
            api.getProjectStatusScoreCards.instance.data?.summaryCards.find(
                (card) => card?.cardTitle.cardType === 'QualityCard',
            ),
        [api.getProjectStatusScoreCards.instance.data],
    );
    const progressCardData = useMemo(
        () =>
            api.getProjectStatusScoreCards.instance.data?.summaryCards.find(
                (card) => card?.cardTitle.cardType === 'ProgressCard',
            ),
        [api.getProjectStatusScoreCards.instance.data],
    );

    const riskCardData = useMemo(
        () =>
            api.getProjectStatusScoreCards.instance.data?.summaryCards.find(
                (card) => card?.cardTitle.cardType === 'RiskCard',
            ),
        [api.getProjectStatusScoreCards.instance.data],
    );

    const showNoData =
        !riskCardData?.cardProperties && !qualityCardData?.cardProperties && !progressCardData?.cardProperties;

    return {
        logic: {
            qualityCardData,
            progressCardData,
            riskCardData,
            showNoData,
        },
    };
};
